export const LAST_VERIFICATION_DETAILS_SUBMISSION_TIME_KEY = 'LAST_VERIFICATION_DETAILS_SUBMISSION_TIME_KEY';
export const PRO_PROFILE_LOCATION_INSTRUCTIONS_FLAG = 'pro_profile_location_instructions_ev4364_20230920';
export const CLIENT_PRO_LOCATION_INSTRUCTIONS_FLAG = 'client_pro_location_instructions_ev4364_20230920';
